module.exports = __webpack_public_path__ + "static/media/happygif.ded35312.gif";